import { transformProductForCompare } from './transformProductForCompare.mjs';
"use strict";
const createEmptyGridItems = ({
  emptyItem,
  numberOfEmptyColumns,
  storeId,
  additionalProductData,
  isMobile
}) => {
  const emptyGridItems = Array.from({
    length: isMobile ? 0 : numberOfEmptyColumns
  }, () => transformProductForCompare({
    product: emptyItem,
    storeId,
    additionalProductData
  }));
  return emptyGridItems;
};
export { createEmptyGridItems };
//# sourceMappingURL=createEmptyGridItems.mjs.map
